module.exports = __webpack_public_path__ + "img/banner2.893ebf38.png";